import { render, staticRenderFns } from "./HostDetails.vue?vue&type=template&id=621c2c4c&"
import script from "./HostDetails.vue?vue&type=script&lang=js&"
export * from "./HostDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports